module.exports = __webpack_public_path__ + "assets/profile_pic.e1d2cfb4580f19d6dac8f0953ba73177.png";